import { render, staticRenderFns } from "./WinningAdsBrandView.vue?vue&type=template&id=cc29a6a4&scoped=true"
import script from "./WinningAdsBrandView.vue?vue&type=script&lang=js"
export * from "./WinningAdsBrandView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc29a6a4",
  null
  
)

export default component.exports